<template>
  <div class="search-list">
    <!-- 自定义顶部导航栏 -->
    <div class="header-box">
      <van-icon name="arrow-left" class="back-icon" @click="$router.go(-1)" />
      
      <div class="search-input-area" @click="$router.push('/search')">
        <div class="fake-input">
          <van-icon name="search" class="search-icon" />
          <span class="placeholder">{{ queryGoodsName || '搜索商品' }}</span>
        </div>
      </div>

      <van-icon name="apps-o" class="cate-icon" @click="$router.push('/category')" />
    </div>

    <!-- 排序按钮 -->
    <div class="sort-btns">
      <div class="sort-item" :class="{ active: sortType === 0 && sortPrice === 0 }" @click="sort1">综合</div>
      <div class="sort-item" :class="{ active: sortType === 1 }" @click="sort2">销量</div>
      <div class="sort-item" :class="{ active: sortType === 0 && sortPrice !== 0 }" @click="sort3">
        价格 <van-icon :name="sortPrice === 1 ? 'arrow-up' : sortPrice === 2 ? 'arrow-down' : 'exchange'" />
      </div>
    </div>

    <!-- 商品列表区域 -->
    <div class="goods-list-wrapper">
      <div class="goods-list">
        <GoodsItem v-for="item in searchGoodsList" :key="item.goods_id" :item="item" />
      </div>
      <!-- 底部导航占位 -->
      <div class="bottom-nav-placeholder"></div>
    </div>
  </div>
</template>

<script>
import { searchListApi } from '@/api/search'
import GoodsItem from '@/components/GoodsItem.vue'

export default {
  name: 'SearchList',
  components: { GoodsItem },
  data() {
    return {
      sortType: 0, 
      sortPrice: 0, 
      categoryId: '',
      page: 1,
      searchGoodsList: []
    }
  },
  computed: {
    queryGoodsName() {
      return this.$route.query.goodsName
    }
  },
  created() {
    this.categoryId = this.$route.query.categoryId
    this.getGoodsList()
  },
  methods: {
    async getGoodsList() {
      const { data: { list } } = await searchListApi({
        sortType: this.sortType,
        sortPrice: this.sortPrice,
        categoryId: this.categoryId,
        goodsName: this.queryGoodsName,
        page: this.page
      })
      this.searchGoodsList = list
    },
    sort1() {
      this.sortType = 0
      this.sortPrice = 0
      this.getGoodsList()
    },
    sort2() {
      this.sortType = 1
      this.sortPrice = 0
      this.getGoodsList()
    },
    sort3() {
      this.sortType = 0
      this.sortPrice = this.sortPrice === 2 ? 0 : this.sortPrice + 1
      this.getGoodsList()
    }
  }
}
</script>

<style lang="less" scoped>
.search-list {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #f6f6f6;
  padding-bottom: 50px; /* 给底部导航留空间 */

  .header-box {
    display: flex;
    align-items: center;
    padding: 10px 15px;
    background-color: #ffffff;
    position: sticky;
    top: 0;
    z-index: 100;
    border-bottom: 1px solid #f5f5f5;

    .back-icon {
      font-size: 24px;
      color: #333;
      cursor: pointer;
      margin-right: 12px;
    }

    .search-input-area {
      flex: 1;
      margin-right: 12px;
      cursor: pointer;

      .fake-input {
        display: flex;
        align-items: center;
        height: 36px;
        background-color: #f2f2f2;
        border-radius: 8px;
        padding: 0 15px;

        .search-icon {
          color: #999;
          font-size: 16px;
          margin-right: 8px;
        }

        .placeholder {
          flex: 1;
          color: #999;
          font-size: 14px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }

    .cate-icon {
      font-size: 24px;
      color: #333;
      cursor: pointer;
    }
  }

  .sort-btns {
    display: flex;
    height: 40px;
    line-height: 40px;
    background-color: #ffffff;
    border-bottom: 1px solid #f5f5f5;

    .sort-item {
      text-align: center;
      flex: 1;
      font-size: 15px;
      color: #666;
      cursor: pointer;
      transition: all 0.2s;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 4px;

      &.active {
        color: #ff6b35;
        font-weight: 600;
      }

      &:active {
        background-color: #fafafa;
      }
    }
  }

  .goods-list-wrapper {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow-y: auto;

    .goods-list {
      padding: 10px 0;
      background-color: #f6f6f6;
    }

    .bottom-nav-placeholder {
      width: 100%;
      height: 50px;
      flex-shrink: 0;
    }
  }
}
</style>